import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles, useTheme } from '@mui/styles'

import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'
import IconAdd from '@assets/images/icons/add.svg'
import clsx from 'clsx'
import Tooltip from '@mui/material/Tooltip'

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    '& :hover': {
      cursor: 'pointer',
    },
  },
  iconContainer: {
    flexShrink: 0,
    color: '#1c7bf1',
    fontWeight: '600',
    border: '1px dashed transparent',
    borderRadius: '50%',
    background: theme.primary,
    width: 28,
    height: 28,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  label: {
    paddingLeft: 10,
    color: '#1c7bf1',
    fontWeight: '600',
  },
  tooltip: {
    fontSize: theme.fontSizes.tooltip,
  },
}))

const InlineIconButton = (props) => {
  const { className, label, icon = IconAdd, dataQsId, onClick = () => {} } = props
  const classes = useStyles(props)
  const theme = useTheme()

  return (
    <div className={clsx(className, classes.container)} onClick={onClick} data-qs-id={dataQsId}>
      <Tooltip title={label} aria-label={label} classes={{ tooltip: classes.tooltip }}>
        <div className={classes.iconContainer}>
          <SVGIcon svg={icon} width='10px' height='10px' fill={theme.white} />
        </div>
      </Tooltip>
      <div className={classes.label}>{label}</div>
    </div>
  )
}

InlineIconButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  icon: PropTypes.node,
  dataQsId: PropTypes.string.isRequired,
}

export default InlineIconButton
